module.exports = __webpack_public_path__ + "img/my-transaction.9316d47c.svg";